import { render, staticRenderFns } from "./FamilySlider.vue?vue&type=template&id=1efbad8c&"
import script from "./FamilySlider.vue?vue&type=script&lang=js&"
export * from "./FamilySlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports